import { Box, Heading, Image, SimpleGrid, Text } from '@chakra-ui/react';
import multipleRewardsIllustration from 'illustrations/multiple_rewards.svg';

const MultipleRewards = () => (
  <SimpleGrid
    columns={[1, 1, 2]}
    pt={[16, 16, 32]}
    pb={[4, 4, 16]}
    alignItems='center'
  >
    <Image src={multipleRewardsIllustration} mx='auto' pb={[8, 8, 0]} />
    <Box>
      <Heading size='2xl' mb={6}>
        Subscribe to{' '}
        <Box as='span' color='cyan.500'>
          multiple
        </Box>{' '}
        reward programs at the same time.
      </Heading>
      <Text color='gray.300' fontSize='lg'>
        Reward programs designed with capital efficiency in mind. Imagine a
        world where a token balance can be reutilised for multiple reward
        programs to earn you even more rewards.
      </Text>
    </Box>
  </SimpleGrid>
);

export default MultipleRewards;
